import React from "react";
import "./index.css";
import { useStore } from "../context";
import { navigate } from "@reach/router";

export default function PrivateRoute({ children }) {
  const { state } = useStore();
  React.useEffect(() => {
    if (!state.token) {
      navigate("/");
    }
  }, [state]); 

  return (
        <>
          {children}
        </>
  );
}
